import { MijnRoute } from '../../mijn-navigatie.model';

export const MAKE_TRANSFER: MijnRoute = {
    path: 'overboeken',
    navigationEvent: 'toOverboeken',
    regex: /^\/overboeken$/,
    webcomponent: 'mijn-overboeken-webcomponent'
};
